import { useQuery } from '@tanstack/react-query';
import { AutoPilotFilters } from '../autopilot/types';
import { getAutopilot } from '../autopilot';

export function useAutopilotHook(filters?: AutoPilotFilters) {
  return useQuery({
    queryKey: ['autopilot', filters],
    queryFn: () => getAutopilot(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}